import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {
  @Input() currentPage: number = 1;
  @Input() totalSize: number = 1;
  @Input() pageSize: number = 100;
  @Output() pageChanged = new EventEmitter<number>();
  pages: number[] = [];
  totalPages: number = this.calculateTotalPages();

  // constructor() {
  //   this.totalPages = this.calculateTotalPages(this.totalRecordCount, this.recordsPerPage);
  // }

  ngOnChanges() {
    this.totalPages = this.calculateTotalPages();
    this.updatePages();
  }

  updatePages() {
    const visiblePages = 5; // Adjust this number to show more/less pages around the current page
    let startPage: number, endPage: number;

    if (this.totalPages <= visiblePages) {
      startPage = 1;
      endPage = this.totalPages;
    } else {
      const half = Math.floor(visiblePages / 2);
      if (this.currentPage <= half) {
        startPage = 1;
        endPage = visiblePages;
      } else if (this.currentPage + half >= this.totalPages) {
        startPage = this.totalPages - visiblePages + 1;
        endPage = this.totalPages;
      } else {
        startPage = this.currentPage - half;
        endPage = this.currentPage + half;
      }
    }

    this.pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChanged.emit(this.currentPage);
      this.updatePages();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pageChanged.emit(this.currentPage);
      this.updatePages();
    }
  }

  goToPage(page: number) {
    if (this.currentPage !== page) {
      this.currentPage = page;
      this.pageChanged.emit(this.currentPage);
      this.updatePages();
    }
  }

  calculateTotalPages(): number {
    return Math.ceil(this.totalSize / this.pageSize);
  }
}
